import { createAction, props } from '@ngrx/store';

import { SUPPORTED_LANGUAGE } from './language.model';

export namespace LanguageActions {
  export enum Type {
    GET_LANGUAGE = '[SETTINGS] Get language',
    GET_LANGUAGE_SUCCESS = '[SETTINGS] Get language success',
    GET_LANGUAGE_ERROR = '[SETTINGS] Get language error',
    SET_LANGUAGE = '[SETTINGS] Set language',
    SET_LANGUAGE_SUCCESS = '[SETTINGS] Set language success',
    SET_LANGUAGE_ERROR = '[SETTINGS] Set language error',
  }

  export const getLanguage = createAction(
    Type.GET_LANGUAGE,
    props<{
      languageCode?: SUPPORTED_LANGUAGE;
    }>()
  );

  export const getLanguageSuccess = createAction(
    Type.GET_LANGUAGE_SUCCESS,
    props<{
      languageCode: SUPPORTED_LANGUAGE;
    }>()
  );

  export const getLanguageError = createAction(Type.GET_LANGUAGE_ERROR);

  export const setLanguage = createAction(
    Type.SET_LANGUAGE,
    props<{
      languageCode: SUPPORTED_LANGUAGE;
    }>()
  );

  export const setLanguageSuccess = createAction(Type.SET_LANGUAGE_SUCCESS);

  export const setLanguageError = createAction(Type.SET_LANGUAGE_ERROR);
}
